import { SvgIconComponent } from "@mui/icons-material";

export type LassoSafeModalProps = {
    isOpen: boolean;
    onClose: () => void;
    state: LassoSafeState;
}

export type LassoSafeState = {
    type: LassoSafeType,
    text: string;
    button?: LassoSafeButton
    color?: string;
    icon?: SvgIconComponent | JSX.Element;
}

export enum LassoSafeInstance  {
    ON_PREMISE,
    CLOUD
}

type LassoSafeButton = {
    text: string;
    action?: () => void;
}

export enum LassoSafeType {
    DEFAULT = "default",
    LOADING = "loading",
    SUCCESS = "success",
    ERROR = "error"
}

export interface CreateLassoSafeUserRequest {
    usernames: string[];
}

export interface LassoSafeUserResult {
    username: string;
    status: 'created' | 'skipped' | 'failed';
    reason?: string;
}

export interface LassoSafeUserSummary {
    total: number;
    created: number;
    skipped: number;
    failed: number;
}

export interface CreateLassoSafeUserResponse {
    summary: LassoSafeUserSummary;
    results: LassoSafeUserResult[];
}

